import anime from 'animejs';

export default class {
    constructor() {
        this.init();
    }

    init() {
        const heroCatch = document.querySelector("#hero--catch");

        setTimeout(() => {
            if (!heroCatch) return;

            // キャッチ全体の英語・日本語の対象
            const heroPrimary = document.querySelectorAll('.hero--catch__en');
            const heroSecondary = document.querySelectorAll('.hero--catch__jp');

            // spanで分割 ＋ 初期非表示（visibility: hidden）解除
            const wrapText = (elements) => {
                elements.forEach((el) => {
                    const chars = el.textContent.trim().split('');
                    let html = '';
                    chars.forEach((char) => {
                        html += `<span class="hero__str">${char}</span>`;
                    });
                    el.innerHTML = html;
                    el.style.visibility = 'visible'; // ← チラ見え防止
                });
            
                // jp全体を表示状態に（複数対応）
                const jpWrappers = document.querySelectorAll('.hero--catch__jp');
                jpWrappers.forEach((jp) => {
                    jp.style.opacity = '1';
                });
            };            

            wrapText(heroPrimary);
            wrapText(heroSecondary);

            // ちょっと遅らせてアニメーション開始
            setTimeout(() => {
                anime.timeline()
                    .add({
                        targets: '.hero--catch__jp .hero__str',
                        translateX: ["20%", 0],
                        opacity: [0, 1],
                        easing: "easeOutQuart",
                        delay: (el, i) => i * 120,
                        duration: 1200,
                    });
            
                anime.timeline()
                    .add({
                        targets: '.hero--catch__en .hero__str',
                        translateX: ["10%", 0],
                        opacity: [0, 1],
                        easing: "easeOutQuart",
                        delay: (el, i) => i * 100,
                        duration: 1000,
                    });
            }, 2200);
            
        }, 1100); // ページ読み込み後ちょっと待つ
    }
}
